import React from "react";
import { downloadWorkbook } from "../../Functionalities/exportWorkbook";
import {
  ONLINE_PAYMENT_AMOUNT,
  columnLabel,
  isPercentageColumn,
} from "../../Functionalities/reportColumns";

const DownloadNew = ({ columns, data, defaultColums, type }) => {
  const exportWorkbook = () => {
    if (type === "Order") {
      const rows = data.map((report) => {
        const row = {};

        columns.forEach((column) => {
          let value = "";

          if (column === "created_time" || column === "updated_time") {
            value = new Date(report[column]).toLocaleDateString("en-GB");
          } else if (column === "franchise" || column === "branch") {
            value = report[column]?.name || "";
          } else if (column === "user_of_intrest" || column === "delivery_boy") {
            value = report[column]?.first_name || "unnamed";
          } else if (column === ONLINE_PAYMENT_AMOUNT) {
            value = report[column] === "--" ? "--" : `₹ ${report[column]}`;
          } else if (column === "foodoor_cares") {
            value = `₹ ${report.foodoor_cares ?? 0}`;
          } else if (
            column === "franchise_charge" ||
            column === "restaurent_charge" ||
            column === "delivery_charge" ||
            column === "incentive" ||
            column === "delivery_boy_tip" ||
            column === "delivery_boy_earn" ||
            column === "amount" ||
            column === "wallet_amount_used" ||
            column === "total_food_amount" ||
            column === "franchise_collected_amount" ||
            column === "commission_amount_on_restaurent" ||
            column === "commission_amount_on_franchise" ||
            column === "refund_amount" ||
            column === "amount_to_restaurant" ||
            column === "amount_credited" ||
            column === "amount_debited"
          ) {
            value = `₹ ${report[column]}`;
          } else if (isPercentageColumn(column)) {
            value = `${report[column]} %`;
          } else if (column === "order") {
            value = `#${report[column]}`;
          } else {
            value = report[column];
          }

          row[column] = value;
        });

        return row;
      });

      const reportName = `Foodoor Report ${new Date()
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")}`;

      downloadWorkbook({
        columns: columns.map((column) => ({
          key: column,
          label: column === "id" ? "Order ID" : columnLabel(column),
        })),
        rows,
        sheetName: reportName,
        fileName: reportName,
      });

      return;
    }

    const rows = data.map((item) => ({
      ...item,
      modifiedDate: item.date.slice(0, 10),
    }));

    downloadWorkbook({
      columns: [
        { key: "id", label: "id" },
        { key: "delivery_boy", label: "Delivery Boy" },
        { key: "modifiedDate", label: "Date" },
        { key: "discription", label: "Description" },
        { key: "order", label: "Order ID" },
        { key: "collected_amt", label: "Collected Amount" },
        { key: "delivery_charge", label: "Delivery Charge" },
        { key: "delivery_tip", label: "Delivery Tip" },
        { key: "submitted_amt", label: "Submitted Amount" },
        { key: "paid_delivery_charge", label: "Paid Amount" },
      ],
      rows,
      sheetName: "Delivery Boy Report",
      fileName: "Delivery Boy Report",
    });
  };

  return (
    <b onClick={exportWorkbook} style={{ cursor: "pointer" }}>
      Export
    </b>
  );
};

export default DownloadNew;
